import request from '@/utils/request'

/**
 * 获取预约表单首页
 * {String} no 课程编号
 * @return {AxiosPromise}
 */
export function getBookingHomeApi (data) {
    return request({
        url: 'share/live/index',
        method: 'post',
        data: data,
    })
}


/**
 * 验图形验证码且发送短信
 * @return {AxiosPromise}
 */
export function checkTencentCodeApi (data) {
    return request({
        url: 'share/live/sendsms',
        method: 'post',
        data: data,
    })
}


/**
 * 提交预约
 * @return {AxiosPromise}
 */
export function submitLiveBookingApi (data) {
    return request({
        url: 'share/live/save',
        method: 'post',
        data: data,
    })
}
